import React, { useState } from 'react'
import BigNumber from 'bignumber.js'
import { getUSDTAddress } from 'utils/addressHelpers'
import styled from 'styled-components'
import { useTranslation } from 'contexts/Localization'
import { Flex, CardFooter, ExpandableLabel, HelpIcon, useTooltip } from '@pixel-nft/uikit'
import { LendingPool, Pool } from 'state/types'
import { CompoundingPoolTag, ManualPoolTag, CoreTag } from 'components/Tags'
import ExpandedFooter from './ExpandedFooter'

const ExpandableButtonWrapper = styled(Flex)`
  align-items: center;
  justify-content: center;
  button {
    padding: 0;
    svg {
      margin-left: 0 !important;
    }
  }
`

const Footer: React.FC = () => {
  const { t } = useTranslation()
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <CardFooter>
      <ExpandableButtonWrapper>
        <ExpandableLabel expanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)}>
          <div style={{ marginLeft: 0 }}>{isExpanded ? t('Hide') : t('Details')}</div>
        </ExpandableLabel>
      </ExpandableButtonWrapper>
      {isExpanded && <ExpandedFooter tokenAddress={getUSDTAddress()} />}
    </CardFooter>
  )
}

export default Footer
